import React from 'react'

const Refund = () => {
  return (
    <div className="container mx-auto py-8 px-4 lg:px-8">
      <h1 className="text-3xl font-bold mb-6 text-gray-800">ChatGPT Enhancer Refund Policy</h1>
      <p className="mb-4 text-gray-700">Welcome to ChatGPT Enhancer, an app. We value your satisfaction and aim to provide you with the best possible experience. Please read our refund policy carefully to understand your rights and our obligations regarding refunds.</p>

      <h2 className="text-2xl font-semibold mb-4 text-gray-800">General Refund Policy</h2>
      <p className="mb-4 text-gray-700">At ChatGPT Enhancer, we strive to ensure your complete satisfaction with our services. If you experience any issues or are dissatisfied with your purchase, please contact us at <a href="mailto:aydometehan@gmail.com" className="text-blue-500 hover:underline">aydometehan@gmail.com</a>.</p>

      <h2 className="text-2xl font-semibold mb-4 text-gray-800">Eligibility for Refunds</h2>
      <p className="mb-4 text-gray-700">Refunds are considered under the following circumstances:</p>

      <ul className="list-disc list-inside mb-6 text-gray-700">
        <li><b className="font-medium">Technical Issues:</b> If you encounter technical problems that prevent you from accessing or using our app's features.</li>
        <li><b className="font-medium">Misrepresentation:</b> If the service does not match the description provided at the time of purchase.</li>
        <li><b className="font-medium">Defective Service:</b> If the service provided is defective or not functioning as intended.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-4 text-gray-800">Refund Requests</h2>
      <p className="mb-4 text-gray-700">To request a refund, please follow these steps:</p>

      <ul className="list-decimal list-inside mb-6 text-gray-700">
        <li><b className="font-medium">Contact Support:</b> Email us at <a href="mailto:aydometehan@gmail.com" className="text-blue-500 hover:underline">aydometehan@gmail.com</a> with your purchase details, including the email used for registration and a description of the issue.</li>
        <li><b className="font-medium">Investigation:</b> Our support team will investigate the issue and may request additional information or screenshots to better understand the problem.</li>
        <li><b className="font-medium">Resolution:</b> We will endeavor to resolve your issue within 5-7 business days. If the problem cannot be resolved, we will process your refund.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-4 text-gray-800">Refund Processing</h2>
      <p className="mb-4 text-gray-700">Refunds will be processed to the original method of payment used at the time of purchase.</p>
      <p className="mb-4 text-gray-700">Please allow up to 10 business days for the refund to appear in your account, depending on your payment provider.</p>

      <h2 className="text-2xl font-semibold mb-4 text-gray-800">Subscription Plans</h2>

      <ul className="list-disc list-inside mb-6 text-gray-700">
        <li>
          <b className="font-medium">Cancellation:</b> You can cancel your subscription at any time through your account settings. Upon cancellation, you will continue to have access to the service until the end of your current billing period.
        </li>
        <li>
          <b className="font-medium">Refunds for Subscriptions:</b> Refunds for subscriptions will be considered only if requested within 14 days of the initial purchase, provided the service has not been used extensively during this period.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mb-4 text-gray-800">Exceptions</h2>
      <p className="mb-4 text-gray-700">Refunds will not be granted under the following conditions:</p>

      <ul className="list-disc list-inside mb-6 text-gray-700">
        <li><b className="font-medium">Change of Mind:</b> Refunds are not provided for change of mind or if you no longer wish to use the service.</li>
        <li><b className="font-medium">Violations of Terms:</b> If you violate our Terms of Service, you are not eligible for a refund.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-4 text-gray-800">Contact Us</h2>
      <p className="mb-8 text-gray-700">If you have any questions or need further assistance, please do not hesitate to contact us at <a href="mailto:aydometehan@gmail.com" className="text-blue-500 hover:underline">aydometehan@gmail.com</a>. We are here to help and ensure your satisfaction with ChatGPT Enhancer.</p>

      <p className="text-gray-700"><b>Effective Date:</b> October 30, 2024</p>
    </div>
  )
}

export default Refund